// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Translations_wrapper__jNRd2","row":"Translations_row__TLPcg","languageTitle":"Translations_languageTitle__xDcMD","languageButton":"Translations_languageButton__MhtoI"};